module.exports = __webpack_public_path__ + "img/class_a.ef65209d.jpg";